<template>
  <div class="patient-services">
    <div class="patient_list">
        <van-search v-model="searchValue" @search="onSearch" left-icon show-action placeholder="按患者姓名搜索" >
            <template #action>
            <div @click="onSearch"><van-icon name="search" size='20' /></div>
            </template>
        </van-search>

        <div class="checkin-btn">
          <van-button type="primary" round color="#0AA8AF" @click="addRecord()" block>新增记录</van-button>
        </div>

        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group inset class="cell-group" v-for="item,index in list" :key="index">
                <van-cell  :border="false">
                    <template #title><div class="grey_label">服务患者:</div></template>   
                    <div>{{item.patient_name}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">服务城市:</div></template>      
                    <div>{{item.city}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">服务项:</div></template>      
                    <div>{{item.service_type}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">咨询方式:</div></template>      
                    <div>{{item.consult_mode}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">咨询时间:</div></template>      
                    <div>{{item.consult_date}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">咨询内容:</div></template>      
                    <div>{{item.remark}}</div> 
                </van-cell>
                <div></div>
                <div style="position:absolute;top:10px;right:16px;display:flex;">
                    <van-icon @click="changeRecord(item)" color="#9D9D9D" name="edit" size="25" />
                    <div style="white-space:nowrap;display:flex;align-items:center;margin-left:6px;color:#9D9D9D;">{{list.length-index}}</div>
                </div>
                
            </van-cell-group>

            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List,Toast,Divider } from 'vant';
import { mapState } from "vuex";
import { getPatientServiceList } from '@/api/publicWelfareStaff';

// import { mapMutations } from "vuex";
Vue.use(Divider);
Vue.use(List);
Vue.use(Toast);
export default {
    data(){
        return {
          searchValue: '',
          page:1,
            
          //无限加载列表
          list: [],
          loading: false,
          finished: false,

          stop:false,
        }
    },
     computed: {
        ...mapState(['publicWelfareStaff']),
    },
    async created(){
        await this.init();
    },
    methods: {
        //   ...mapMutations(['setOriginRoute']),

        async init(){
             
        },
        async fetchData(keyword,page){
            let DATA
            let sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                keyword:keyword,
                service:1,
                page:page
            }
            if(!keyword) delete sendData.keyword
            await getPatientServiceList(sendData).then(res => {
                if(res.data){
                    DATA=res.data
                    console.log("getPatientServiceList",res)
                    this.list=[...this.list,...res.data]
                }
            }).catch(err => {

            })
            return DATA
        },

      async onSearch(){
        if(this.stop==true) return
        Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
        console.log("搜索的值",this.searchValue)
        this.page=1
        this.list=[]
        await this.fetchData(this.searchValue,this.page)
        this.page++
        this.finished = false;
        Toast.clear();
      },
       async onLoad() {
        // 异步更新数据
        this.stop=true;
        await this.fetchData(this.searchValue,this.page).then(res => {
            console.log("fetchData",res)
            if (res.length>0) this.page++

            // 加载状态结束
            this.loading = false;

            // 数据全部加载完成
            if (res.length==0) {
                this.finished = true;
            }
        })
        this.stop=false
      },
      addRecord(){
        // 新增/修改记录
        console.log("新增记录")
        //存储返回的路径名
        // this.$store.commit("setOriginRoute", this.$route.name);
        
        this.$router.push({name:'addService',query:{title:"新增患者服务",}})
      },
      changeRecord(item){
        this.$store.commit("setPatient_service_item", item);
        console.log("修改记录")
        let queryData={
            title:"更新患者服务",
        }
        this.$router.push({name:'addService',query:queryData})
      }
    }
}
</script>

<style lang="scss" scoped>
.patient-services{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
      box-shadow: 0 -2px 6px rgba(73, 46, 46, 0.2);
      padding-bottom: 44px;
        .checkin-btn {
            margin: 25px;
        }
        .cell-group{
            margin-bottom:10px;
            .van-cell__title {
                flex: 1;
                text-align: right;
                margin-right: 10px;
            }
            .van-cell__value{
                flex: 3;
                color:#0A0A0A;
                white-space:nowrap;
                text-align: left;
                // display:flex;
                // justify-content:flex-start;
                // align-items:center;
            .alignment-flex{
                display:flex;
                justify-content:flex-start;
                align-items:flex-start;
            }
            }
        }
      
    }
}
</style>